import { useTranslation } from 'react-i18next';
import { MarketAccessory, MarketActionCard, MarketRow } from '@market/react';
import ApplePayLogo from 'images/icons/apple-pay.svg';

const ApplePay = (props) => {
  const { t } = useTranslation();
  const { submitting, tokenize } = props;

  return (
    <MarketActionCard
      {...(submitting && { disabled: true })}
      onClick={tokenize}
      style={{ margin: '20px 0px' }}
    >
      <MarketRow variant="drill">
        <MarketAccessory
          slot="leading-accessory"
          style={{ width: '60px', height: '40px' }}
        >
          <img src={ApplePayLogo} style={{ height: '95%' }} />
        </MarketAccessory>
        <label slot="label">{t('checkout.payment.payWithApplePay')}</label>
      </MarketRow>
    </MarketActionCard>
  );
};

export default ApplePay;
